import { render, staticRenderFns } from "./Agents.vue?vue&type=template&id=0964b7d2&"
import script from "./Agents.vue?vue&type=script&lang=js&"
export * from "./Agents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports